/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import SimplicityImage from "@/assets/shipping-advantage-simplicity.svg";
import EfficiencyImage from "@/assets/shipping-advantage-efficiency.svg";
import FlexibilityImage from "@/assets/shipping-advantage-flexibility.svg";
import TransparencyImage from "@/assets/shipping-advantage-transparency.svg";
import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";
import ReactMarkdown from "react-markdown";


const data = {
  // title: {
  //   en: <>Why choose <strong>Zapptax Shipping?</strong></>,
  //   fr: <>Pourquoi choisir <strong>Zapptax Shipping{X.Nbsp}?</strong></>,
  //   ko: <>왜 Zapptax Shipping을 선택해야 하나요?</>,
  // },

  // cta: {
  //   en: "Contact us",
  //   fr: "Contactez-nous",
  //   ko: "문의하기",
  // },

  advantages: [
    {
      image: SimplicityImage,
      // title: { en: `Simplicity`, fr: `Facilité`, ko: `간소한 절차` },
      // text: {
      //   en: `Avoid the hassle and complexity of dealing with local tax and customs authorities in each EU country. We handle the process for you - end to end.`,
      //   fr: `Éviter les tracas et la complexité des relations avec les autorités fiscales et douanières locales dans chaque État membre de l'UE. Nous gérons tout le processus pour vous.`,
      //   ko: `각 EU 국가의 복잡한 세무 및 통관 절차는 저희가 대신 처리해 드립니다.전 과정을 원스톱으로 대행해드립니다.`,
      // },
    },
    {
      image: EfficiencyImage,
      // title: { en: `Operational efficiency`, fr: `Efficacité opérationnelle`, ko: `효율적인 운용` },
      // text: {
      //   en: `Traders and professional buyers placing frequent or high-value orders benefit from a streamlined process and premium support.`,
      //   fr: `Les traders et clients professionnels avec des commandes en gros ou de grande valeur bénéficient d'un traitement simplifié et d'un support premium.`,
      //   ko: `정기적 대량 구매 또는 고가 주문을 진행하는 전문 거래 고객께는 보다 효율적인 절차와  프리미엄 지원 혜택이 제공됩니다.`,
      // },
    },
    {
      image: FlexibilityImage,
      // title: { en: `Flexibility`, fr: `Flexibilité`, ko: `유연성` },
      // text: {
      //   en: `Shop from any retailer — in-store or online. We offer shipping options to most non-EU countries.`,
      //   fr: `Achetez chez n'importe quel commerçant (en magasin ou en ligne). Nous proposons des options d'expédition vers la plupart des pays hors de l'UE.`,
      //   ko: `오프라인 매장부터 온라인 쇼핑까지, 언제 어디서든 구매하실 수 있으며, EU 외 대부분의 국가로도 배송해드립니다.`,
      // },
    },
    {
      image: TransparencyImage,
      // title: { en: `Transparent pricing`, fr: `Tarification transparente`, ko: `합리적인 가격` },
      // text: {
      //   en: `Competitive service fees and consolidated shipment ensure cost optimization.`,
      //   fr: `Des frais de service compétitifs et des expéditions consolidées garantissent une optimisation des coûts.`,
      //   ko: `경쟁력 있는 서비스 수수료와 통합 물류 서비스를 통해 비용을 효과적으로 절감할 수 있습니다.`,
      // },
    },
  ],
};


export function WhyChooseUsSection(props: X.PageProps) {
  return (
    <section id="why" className="scroll-mt-[120px] mt-12">
      <Mobile {...props} />
      <Desktop {...props} />
    </section>
  );
}


function Mobile(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const [openIndex, setOpenIndex] = X.useState<number | null>(null);

  const whyZapptaxCard = useShippingPage('whyZapptaxCard');
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "bg-surface-purple rounded-tr-4xl mr-mobile-margin-half pr-mobile-margin-half pl-mobile-margin",
      "py-8 gap-8 flex flex-col",
    )}>
      {/* <h2 className="text-[34px] [&_strong]:font-medium leading-tight">
        {tr(data.title)}
        </h2> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="text-[34px] [&_strong]:font-medium leading-tight" />
      }}>
        {/* {tr({
          en: whyZapptaxCard.title,
          fr: whyZapptaxCard.title,
          ko: "왜 Zapptax Shipping을 선택해야 하나요?",
          zh: ""
        })} */}
        {whyZapptaxCard.title}
      </ReactMarkdown>

      <div>
        {whyZapptaxCard.items.map((advantage, i) => (
          data.advantages[i] && <AccordionItem
            key={i}
            title={
              advantage.title
              //   tr({
              //   en: advantage.title,
              //   fr: advantage.title,
              //   ko: data.advantages[i].title['ko'],
              //   zh: ""
              // })
            }
            toggleOpen={() => setOpenIndex(openIndex => openIndex === i ? null : i)}
            isOpen={openIndex === i}
          >
            <div className="flex flex-row items-start gap-6">
              <X.Image src={data.advantages[i].image} alt={`Advantage ${i + 1}`} className="w-[70px] h-auto" />
              {/* <p className="text-20px">
                 tr({
                     fr: advantage.content,
                     en: advantage.content,
                     ko: data.advantages[i].text['ko'],
                     zh: ""
                   })
                  {advantage.content}
                  </p> */}
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-20px" />
              }}>
                {advantage.content}
              </ReactMarkdown>
            </div>
          </AccordionItem>
        ))}
        {/* {data.advantages.map((advantage, i) => (
          <AccordionItem
            key={i}
            title={tr(advantage.title)}
            toggleOpen={() => setOpenIndex(openIndex => openIndex === i ? null : i)}
            isOpen={openIndex === i}
          >
            <div className="flex flex-row items-start gap-6">
              <X.Image src={advantage.image} alt={`Advantage ${i + 1}`} className="w-[70px] h-auto" />
              <p className="text-20px">{tr(advantage.text)}</p>
            </div>
          </AccordionItem>
        ))} */}
      </div>

      <div className="flex flex-col items-start">
        <X.Button
          primary
          // label={tr(data.cta)}
          label={
            whyZapptaxCard.cta
            //   tr({
            //   fr: whyZapptaxCard.cta,
            //   en: whyZapptaxCard.cta,
            //   ko: data.cta.ko,
            //   zh: ""
            // })
          }
          className="X-Open-Intercom"
        />
      </div>
    </div>
  );
}


function Desktop(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const whyZapptaxCard = useShippingPage('whyZapptaxCard');
  return (
    <div className={X.clsx(X.desktopOnly("flex"), "bg-surface-purple rounded-4xl p-12 flex flex-col gap-12 max-w-content mx-auto mb-20")}>
      {/* <h2 className="text-[48px] [&_strong]:font-medium text-center mb-8">{tr(data.title)}</h2> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="text-[48px] [&_strong]:font-medium text-center mb-8" />
      }}>
        {/* {tr({
          en: whyZapptaxCard.title,
          fr: whyZapptaxCard.title,
          ko: "왜 Zapptax Shipping을 선택해야 하나요?",
          zh: ""
        })} */}
        {whyZapptaxCard.title}
      </ReactMarkdown>
      <div className="flex flex-row gap-12">
        {whyZapptaxCard.items.map((advantage, i) => (
          data.advantages[i] && <div key={i} className="flex-1 flex flex-col items-center gap-4">
            <X.Image src={data.advantages[i].image} alt={`Advantage ${i + 1}`} className="h-[90px] w-auto mb-4" />
            {/* <h3 className="text-[26px] font-semibold leading-tight text-center px-2">
              {tr({
                en: advantage.title,
                fr: advantage.title,
                ko: data.advantages[i].title['ko'],
                zh: ""
              })}
              {advantage.title}
            </h3> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold leading-tight text-center px-2 [&_strong]:font-bold" />,
              h1: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold leading-tight text-center px-2 [&_strong]:font-bold" />,
              h2: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold leading-tight text-center px-2 [&_strong]:font-bold" />,
              h3: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold leading-tight text-center px-2 [&_strong]:font-bold" />,
              h4: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold leading-tight text-center px-2 [&_strong]:font-bold" />
            }}>
              {advantage.title}
            </ReactMarkdown>
            <ReactMarkdown
              components={{
                p: ({ ...props }) => <p {...props} className="text-[20px] leading-tight text-center" />
              }}>
              {advantage.content}
            </ReactMarkdown>
            {/* <p className="text-[20px] leading-tight text-center">
              {tr({
              fr: advantage.content,
              en: advantage.content,
              ko: data.advantages[i].text['ko'],
              zh: ""
            })}
              {advantage.content}
            </p> */}
          </div>
        ))}
      </div>
      {/* <div className="flex flex-row gap-12">
        {data.advantages.map((advantage, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-4">
            <X.Image src={advantage.image} alt={`Advantage ${i + 1}`} className="h-[90px] w-auto mb-4" />
            <h3 className="text-[26px] font-semibold leading-tight text-center px-2">{tr(advantage.title)}</h3>
            <p className="text-[20px] leading-tight text-center">{tr(advantage.text)}</p>
          </div>
        ))}
      </div> */}

      <div className="flex flex-col items-center">
        <X.Button
          primary lg
          label={
            whyZapptaxCard.cta
            //   tr({
            //   fr: whyZapptaxCard.cta,
            //   en: whyZapptaxCard.cta,
            //   ko: data.cta.ko,
            //   zh: ""
            // })
          }
          // label={tr(data.cta)}
          className="X-Open-Intercom"
        />
      </div>
    </div>
  );
}


function AccordionItem(props: {
  title: React.ReactNode;
  children: React.ReactNode;
  toggleOpen: () => void;
  isOpen: boolean;
}) {
  const iconStyle = "rounded-full p-1"

  const ref = X.useRef<HTMLDivElement>(null);
  const [height, setHeight] = X.useState("0px");

  X.useEffect([props.isOpen], () => {
    if (!ref.current) {
      return;
    }

    setHeight(props.isOpen ? `${ref.current.scrollHeight}px` : "0px");
  });

  return (
    <div className="border-b border-gray-300">
      <div
        onClick={props.toggleOpen}
        className={X.clsx(
          "flex justify-between items-center w-full text-left cursor-pointer",
          "pt-3 pb-3 xl:pt-4 xl:pb-6 gap-4 hover:text-black/50"
        )}
      >

        {
          typeof props.title === "string"
            ? <ReactMarkdown
              components={{
                p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[24px] select-none" />
              }}
            >{props.title}</ReactMarkdown>
            : <p className="text-[16px] xl:text-[24px] select-none">props.title</p>
        }

        <div className="flex-1 flex justify-end">
          {props.isOpen ? (
            <X.Icon.X size={28} className={X.clsx(iconStyle, "bg-black text-white")} />
          ) : (
            <X.Icon.Plus size={28} className={X.clsx(iconStyle, "bg-white color-black")} />
          )}
        </div>
      </div>

      <div
        ref={ref}
        style={{ height }}
        className={X.clsx(
          "overflow-hidden transition-[height] duration-300 ease-in-out",
        )}
      >
        <div className={X.clsx("mt-2 pb-6")}>
          {typeof props.children === "string"
            ? <ReactMarkdown>{props.children}</ReactMarkdown>
            : props.children}
        </div>
      </div>

    </div>
  );
}
